import React from "react";

/**
 * @file Plans.js
 * @description Platform settings and global configuration page.
 */
export default function Plans() { // Platform Settings
  return (
    <div className="p-4 bg-light min-vh-100">
      <div className="mb-4">
        <h4 className="fw-bold mb-1">Platform Settings</h4>
        <p className="text-muted small">Configure global platform settings, plans, and limits.</p>
      </div>

      <div className="card border-0 shadow-sm p-4">
        <h6 className="fw-bold mb-3">Global Configuration</h6>
        <div className="mb-3">
          <label className="form-label">Platform Name</label>
          <input type="text" className="form-control" defaultValue="WiiZ SaaS Platform" />
        </div>
        <div className="mb-3">
          <label className="form-label">Support Email</label>
          <input type="email" className="form-control" defaultValue="support@wiiz.ai" />
        </div>
        <div className="form-check form-switch mb-3">
          <input className="form-check-input" type="checkbox" checked readOnly />
          <label className="form-check-label">Enable Maintenance Mode</label>
        </div>
        <button className="btn btn-primary">Save Changes</button>
      </div>
    </div>
  );
}